export const haveOptionsChanged = (prev, next) => {
    if (prev.length !== next.length)
        return true;
    for (let i = 0; i < next.length; i += 1) {
        const p = prev[i];
        const n = next[i];
        if (p.id !== n.id || p.label !== n.label) {
            return true;
        }
    }
    return false;
};
export const focusOnInput = (wrapperRef) => {
    var _a;
    const childEls = (_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.children;
    if (childEls) {
        Array.from(childEls).forEach(child => {
            if (child.tagName === 'INPUT')
                child.focus();
        });
    }
};
export const containsFocus = (wrapperRef) => {
    var _a;
    return !!((_a = wrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement));
};
//# sourceMappingURL=utils.js.map